import { PreHangCartOptions, PreHangOption } from "@/types/preHang";
import { Common } from "@/util/common";
import { PreHangCache } from "./ph-cache";

export class JambsStops {
    private Cache: PreHangCache
    public customJambWidthOptions = Common.createMeasurementOptionsBySixteenths('3','6-9/16',11)
    public additionalJambs: number
    public additionalStops: number
    public isBifoldDoor = false
    public customJambWidth: PreHangOption | null

    public constructor(preHangOptions: PreHangCartOptions | null, isBifoldDoor: boolean, Cache:PreHangCache) {
        this.Cache = Cache
        this.additionalJambs = preHangOptions?.additionalJambs ?? 0
        this.additionalStops = preHangOptions?.additionalStops ?? 0
        this.isBifoldDoor = isBifoldDoor
        this.customJambWidth = this.initCustomJambWidth(preHangOptions?.customJambWidth, this.Cache.cachedSelections.customJambWidth)

    }

    private initCustomJambWidth(cartWidth: string | undefined, cacheWidth: string | null) {
        const value = cartWidth ?? cacheWidth

        return (value) ? this.buildCustomJambWidthOption(value) : null
    }

    private buildCustomJambWidthOption(width: string) {
        return {
            id: Common.countSixteenths(width),
            name: width,
            preHangCategoryId: 11,
            price: 0
        }
    }

    public updateJambsCount(count: number) {
        this.additionalJambs = count
    }

    public updateStopsCount(count: number) {
        this.additionalStops = count
    }

    public updateCustomJambWidth(option: PreHangOption) {
        this.customJambWidth = option
        this.Cache.addToCache('customJambWidth', option.name)
    }
}